import type {Context} from '../types';

export default (context: Context) => {
  const {jsonNode} = context.node;
  const {data = {}} = jsonNode;

  const isWidthNumber =
    Boolean(data?.attr?.width) && typeof data.attr.width === 'number';
  const isHeightNumber =
    Boolean(data?.attr?.height) && typeof data.attr.height === 'number';

  return {
    needed: jsonNode.type === 'Image' && (isWidthNumber || isHeightNumber),
    logData: {
      msg: 'Convert Image width and height from number to string',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (isWidthNumber) {
        data.attr.width = String(data.attr.width);
      }

      if (isHeightNumber) {
        data.attr.height = String(data.attr.height);
      }
    },
  };
};
